import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigsLoaderService } from '../config-loader.service';
import { Item } from 'app/models/item.inferface';
import { ISuggestService } from 'app/shared/components/suggest-input/model/ISuggestService';
import { ClientItem } from 'app/models/client-item';

@Injectable({
  providedIn: 'root'
})
export class ClientByNameSuggestService implements ISuggestService<ClientItem> {

  private apiEndpoint = '';
  headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');

  constructor(
    private httpClient: HttpClient,
    private config: ConfigsLoaderService,
  ) {
    this.apiEndpoint = this.config.apiUrl;
  }

  getSuggestByDescription(description: string): Observable<ClientItem[]> {
    const params = new HttpParams()
      .append('name', description);

    return this.httpClient.get<ClientItem[]>(`${this.apiEndpoint}/DataSource/GetClientsByName/`, { params })
      .pipe(
        map(response => {
          return response;
        }),
      );
  }
}


